import type { ReactNode } from 'react';
import type { User } from '../../types';

type Props = {
  loading: boolean;
  membersCount: number;
  owners: User[];
  pendingMembers: User[];
  others: User[];
  isAdmin: boolean;
  renderMember: (member: User) => ReactNode;
};

export default function MembersGroups({
  loading,
  membersCount,
  owners,
  pendingMembers,
  others,
  isAdmin,
  renderMember,
}: Props) {
  if (loading) {
    return <p className="members-hint">Загрузка...</p>;
  }
  if (membersCount === 0) {
    return <p className="members-hint">Нет участников</p>;
  }
  return (
    <div className="members-groups">
      {owners.length > 0 ? (
        <section
          className="members-group"
          aria-labelledby="members-owners-title"
        >
          <div className="members-group-head">
            <h3 id="members-owners-title" className="members-group-title">
              Собственники
            </h3>
            <p className="members-group-subtitle">
              Владелец, админ, пилот — доли на карточке самолёта
            </p>
          </div>
          <div className="members-cards">
            {owners.map(renderMember)}
          </div>
        </section>
      ) : null}

      {pendingMembers.length > 0 ? (
        <section
          className="members-group"
          aria-labelledby="members-pending-title"
        >
          <div className="members-group-head">
            <h3 id="members-pending-title" className="members-group-title">
              Ожидают активации
            </h3>
            <p className="members-group-subtitle">
              {isAdmin
                ? 'Назначьте доли, чтобы активировать участника'
                : 'Ещё не активированы'}
            </p>
          </div>
          <div className="members-cards">
            {pendingMembers.map(renderMember)}
          </div>
        </section>
      ) : null}

      {others.length > 0 ? (
        <section
          className="members-group members-group-others"
          aria-labelledby="members-others-title"
        >
          <div className="members-group-head">
            <h3 id="members-others-title" className="members-group-title">
              Прочие роли
            </h3>
            <p className="members-group-subtitle">
              Модератор, техник, гость, владелец без доли и неактивные — без
              доли владения
            </p>
          </div>
          <div className="members-cards">{others.map(renderMember)}</div>
        </section>
      ) : null}
    </div>
  );
}
